import { CoreInterfaces } from "./../../Models";
import * as Constants from "../../Constants/Constants";

export function configurationReducer(
  state: CoreInterfaces.AppState,
  action: { type: Constants.AppStateActions; payload?: any }
): Partial<CoreInterfaces.AppState> {
  switch (action.type) {
    case Constants.AppStateActions.UpdateRateCartsConfiguration: {
      const actionPayload =
        action.payload as CoreInterfaces.RateCartConfiguration;
      const nextState: CoreInterfaces.AppState = {
        ...state,
        currentConfiguration: {
          ...state.currentConfiguration,
          applicationConfiguration: {
            ...state.currentConfiguration.applicationConfiguration,
            rateCartConfiguration: actionPayload,
          },
        },
      };
      return nextState;
    }
    case Constants.AppStateActions.UpdateHiddenFromImportingState: {
      const { status } = action.payload;
      const nextState = {
        ...state,
        currentConfiguration: {
          ...state.currentConfiguration,
          isHiddenFromImporting: status,
        },
      };
      return nextState;
    }
    case Constants.AppStateActions.UpdateConsent: {
      const actionPayload = action.payload;
      const nextState = {
        ...state,
        currentConfiguration: {
          ...state.currentConfiguration,
          consent: actionPayload,
        },
      };
      return nextState;
    }
    case Constants.AppStateActions.UpdateEngagementDocumentsMetadata: {
      const {
        currentUser,
        generationDate,
        version,
      }: {
        currentUser: CoreInterfaces.Employee;
        generationDate: Date;
        version: number;
      } = action.payload;
      const nextState: CoreInterfaces.AppState = {
        ...state,
      };
      nextState.currentConfiguration.engagementLetterMetadata = {
        version,
        createdBy: currentUser,
        createdDate: generationDate,
      };

      return nextState;
    }
    case Constants.AppStateActions.UpdateTotalCostManualOverride: {
      const payload = action.payload as number;
      const nextState: CoreInterfaces.AppState = {
        ...state,
        currentConfiguration: {
          ...state.currentConfiguration,
          totalCostManualOverride: payload,
        },
      };
      return nextState;
    }
    case Constants.AppStateActions.ApplicationConfigurationVersionsChanged: {
      const payload =
        action.payload as CoreInterfaces.ApplicationConfigurationVersios;
      const nextState = {
        ...state,
        applicationConfCurrentVersions: payload,
      };

      return nextState;
    }
    default:
      return {};
  }
}
